// src/pages/Redirect.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { State } from '../state/reducers'; // adjust if you renamed this

const Redirect: React.FC = () => {
  const navigate = useNavigate();
  const user = useSelector((state: State) => state.accountState.user); // or however you're storing the user

  useEffect(() => {
    if (!user) return;

    // Example role-based routing
    switch (user.role) {
      case 'Admin':
      case 'Support':
      case 'Client':
      case 'Client Plus':
      case 'Syndication Partner':
        navigate('/vehicles');
        break;
      case 'Billing':
        navigate('/billing');
        break;
      case 'Auditor':
        navigate('/vehicles');
        // navigate('/reporting');
        break;
      default:
        navigate('/not-authorized');
    }
  }, [user, navigate]);

  return null; // optionally show a loading spinner or message while redirecting
};

export default Redirect;
